import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {

  private isForbiddenHandled = false;

  constructor(
    private snackbarService: SnackbarService,
    private router: Router
  ) {}

  handleError(error: HttpErrorResponse | { message: string }) {


    let errorMessage = 'An unexpected error occurred.';

   
    if (!(error instanceof HttpErrorResponse)) {
      errorMessage = error?.message || errorMessage;
      //this.snackbarService.showError(errorMessage);
      return throwError(() => new Error(errorMessage));
    }

    if (error.status === 0) {
      errorMessage = 'Unable to connect to server. Please check your internet or try again later.';

      //this.snackbarService.showError(errorMessage, 'error');
      return throwError(() => new Error(errorMessage));
    }


    if (error.status === 403) {
      if (!this.isForbiddenHandled) {
        this.isForbiddenHandled = true;

        //this.snackbarService.showError('Forbidden - You are not authorized to access this resource', 'error');

        this.router.navigate(['/staff-login']);

        setTimeout(() => {
          this.isForbiddenHandled = false;
        }, 3000);
      }

      return throwError(() => new Error('Forbidden'));
    }

    // Client-side error
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    }

    // Server-side error
    else {

      let serverErrorMessage = '';

      if (typeof error.error === 'string') {
        try {
          const parsed = JSON.parse(error.error);
          serverErrorMessage =
            parsed?.error ||
            parsed?.message ||
            '';
        } catch {
          serverErrorMessage = error.error;
        }
      }

      else if (typeof error.error === 'object' && error.error !== null) {
        serverErrorMessage =
          error.error?.message ||
          error.error?.error ||
          '';
      }

      // Ignore statusText completely (prevents "OK")
      if (serverErrorMessage && serverErrorMessage !== 'OK') {
        errorMessage = serverErrorMessage;
      } else {
        switch (error.status) {
          case 400:
            errorMessage = 'Bad Request';
            break;

          case 401:
            errorMessage = 'Unauthorized - Please login again';
            this.router.navigate(['/staff-login']);
            break;

          case 404:
            errorMessage = 'Resource Not Found';
            break;

          case 409:
            errorMessage = 'Conflict occurred';
            break;

          case 500:
            errorMessage = 'Internal Server Error';
            break;

          default:
            errorMessage = `Error ${error.status}`;
        }
      }
    }

    //this.snackbarService.showError(errorMessage, 'error');



    return throwError(() => new Error(errorMessage));
  }
}